module.exports = __webpack_public_path__ + "static/Royal_Blue_Grocery_pin-e23f3f4acd945d0165a7dbde8035ed1f.png";